import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SpaceField from "@/components/landing/SpaceField";
import Hero from "@/components/landing/Hero";

const LandingPage = () => (
  <div data-testid="landing-page" className="relative min-h-screen bg-[#020409] text-slate-100">
    <SpaceField />
    <div className="relative" style={{ zIndex: 1 }}>
      <main>
        <Hero />
      </main>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
